import React, { useState, useEffect } from 'react';
import { Image, Form, Message, Button } from 'semantic-ui-react';
import infoIcon from '../../../assets/svg/info.svg';
import { formatCurrency, dateType}  from '../../../utils/stringsAndFormats';
import { payDebt } from '../../../api/deudas';
import { image } from "../../../assets";
import "./StepThree.scss";
import Alert from '../../Shared/Alert/Alert'
import { ENV, saveIdToLocalStorage, saveJsonToLocalStorage, maskString } from "../../../utils";

function StepThree({ selectedDebt, prevStep, setLoading  }) {

  const data = selectedDebt.selectedDebt;
  const idLegado = data.type === 'Credito' ? ENV.CREDIT_LEGACY_ID : ENV.OBLIGATION_LEGACY_ID;
  const valor = data.opcion === 'total' ? (data.type === 'Credito' ? data.descriptionValue1 : data.description1)  : data.opcion === 'minimo' ? data.totalValue : data.valor;
  
  const [error, setError] = useState(null);
  const [alertType, setAlertType] = useState(null);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [phoneError, setPhoneError] = useState(null);
  const [emailError, setEmailError] = useState(null);

  useEffect(() => {
    setIsButtonDisabled(!(isEmailValid && isPhoneValid));
  }, [isEmailValid, isPhoneValid]);

  const handleEmailChange = (e) => {
    const emailRegex = /^\S+@\S+\.\S+$/;
    const value = e.target.value.replace(/\s/g, "");
    setEmail(value);
    if (value.length === 0) {
      setIsEmailValid(false);
      setEmailError("Este campo es obligatorio")
    } else if (!emailRegex.test(value)) {
      setIsEmailValid(false);
      setEmailError("Correo electrónico inválido");
    } else {
      setIsEmailValid(true);
      setEmailError(null)
    }
  };

  const handlePhoneChange = (e) => {
    const numberRegex = /^[0-9]*$/;
    const value = e.target.value;
    setPhone(value);

    if (!numberRegex.test(value)) {
      setPhoneError("Este campo solamente permite números.");
      setIsPhoneValid(false);
    } else if (value.length === 0) {
      setIsPhoneValid(false);
      setPhoneError("Este campo es obligatorio");
    } else if (value.length !== 10) {
      setIsPhoneValid(false);
      setPhoneError("Debes ingresar 10 dígitos");
    } else if (value[0] !== "3") {
      setIsPhoneValid(false);
      setPhoneError("El número debe iniciar con 3");
    } else {
      setIsPhoneValid(true);
      setPhoneError(null);
    }
  };

  const handlePay = async () => {

    setError(null);
    setLoading(true);

    const payload = {
      cliente: {
        documento: {
          tipo: data.documentType,
          numero: data.documentNumber
        },
        nombre: {
          primero: data.firstName,
          primerApellido: data.secondName
        },
        celular: phone,
        correoElectronico: email
      },
      canal: {
        url: ENV.PATHS.FRONT,
        idLegado: idLegado
      },
      facturas: [
        {
          referencia: [
            {
              descripcion: 'numero',
              valor: data.chanel
            },
            {
              descripcion: 'valor',
              valor: valor
            }
          ]

        }
      ]
    };

    try {
      const response = await payDebt(payload);
      if (response.code === '200') {
        saveIdToLocalStorage(response.body.recaudo.pago.codigo);
        saveJsonToLocalStorage(data);

        if (data.classObject !== "ReservaHotelera") {
          window.location.href = response.body.recaudo.pago.url;
        } else {
          setAlertType('blue');
          setError(ENV.TEXT.MSG_LINK_SENT);
          setIsButtonDisabled(true);
        }
       
      } else {
        setAlertType('yellow');
        setError(ENV.TEXT.ERROR_ALERT_CREATE_PAY);
      }
    } catch (error) {
      setAlertType('yellow');
      setError(ENV.TEXT.ERROR_ALERT_CREATE_PAY);
    } finally {
      setLoading(false);
    }
  };

  const preventPasteAndDrop = (e) => e.preventDefault();


  return (
    <div className="steps-container">
      <div className="steps-title"><strong>Paso 3 de 4:</strong> Información del pago</div>

      {error && <Alert errorMessage={error} styleType={alertType} />}

      <div id="exit-up" className="custom-back-button active" onClick={prevStep} style={{ cursor:'pointer' }}>
        <div className="button-back-icon" />
        <span className="button-back-text">Volver</span>
      </div>

      <p className="steps-text-big-out mt-1">Datos de contacto</p>
      <p className="steps-text-out">Ingresa tu correo electrónico y número telefónico.</p>

      <div className="grid-container">
        
        <div className="step-card">
          <p className="steps-text-big">Datos de contacto</p>
          <p className="steps-text">Ingresa tu correo electrónico y número telefónico.</p>
            <Form id="informacion_del_pago">
              <Form.Field>
                <label>Correo electrónico</label>
                <Form.Input 
                  id="email"
                  className={emailError ? 'err-input' : ''}
                  placeholder='Ej.: micuenta@gmail.com'
                  value={email}
                  onChange={handleEmailChange}
                  onPaste={preventPasteAndDrop}
                  onDrop={preventPasteAndDrop}
                  error={!!emailError}
                />
                {emailError && <div className="error-label">{emailError}</div>}
              </Form.Field>
              <Form.Field>
                <label>Número de celular</label>
                <Form.Input
                  id="celular_wha"
                  className={phoneError ? 'err-input' : ''}
                  placeholder='Ej.: 3210000010'
                  value={phone}
                  onChange={handlePhoneChange}
                  onPaste={preventPasteAndDrop}
                  onDrop={preventPasteAndDrop}
                  error={!!phoneError}
                />
                 {phoneError && <div className="error-label">{phoneError}</div>}
              </Form.Field>
            </Form>
            <Message icon id='wp' className={phoneError ? 'err-msg' : ''}>
              <img src={infoIcon} alt="icono" />
              <Message.Content>
                Verifica los datos de contacto y el resumen del pago antes de continuar con la transacción para pagar con PSE.
              </Message.Content>
            </Message>
        </div>
        
        <div className="step-card-mini">
          <p className="step-title">Resumen del pago</p>
          <div className="step-flex">
            <div className="step-text-left">Producto a pagar</div>
            <div className="step-text-right">{data.descriptionValue}</div>
          </div>
          
          {data.classObject !== "ReservaHotelera" ? (
            <>
              <div className="step-flex">
                <div className="step-text-left">Número de producto</div>
                <div className="step-text-right">{maskString(data.billNumber)}</div>
              </div>
              <div className="step-flex">
                <div className="step-text-left">{dateType(data.type)}</div>
                <div className="step-text-right">{data.description2}</div>
              </div>
            </>
          ) : (
            <>
              <div className="step-flex">
                <div className="step-text-left">Nombre del cliente</div>
                <div className="step-text-right">{data.descriptionValue1}</div>
              </div>
              <div className="step-flex">
                <div className="step-text-left">Número de documento</div>
                <div className="step-text-right">{data.documentNumber}</div>
              </div>
              <div className="step-flex">
                <div className="step-text-left">Número de reserva</div>
                <div className="step-text-right">{data.billNumber}</div>
              </div>
              <div className="step-flex">
                <div className="step-text-left">Hotel</div>
                <div className="step-text-right">{data.descriptionValue2}</div>
              </div>
              <div className="step-flex">
                <div className="step-text-left">Valor de la reserva</div>
                <div className="step-text-right">{formatCurrency(data.totalValue)}</div>
              </div>
            </>
          )}

          
          <hr className="custom-step-separator" />

          <div className="step-flex">
            <div className="step-text-total">Total a pagar:</div>
            <div className="step-text-value">{formatCurrency(valor)}</div>
          </div>
        </div>

      </div>

      <div className="grid-container"  style={{ paddingTop: '1.5rem' }}>
        <div id="exit-down" className="botonera-izq">
          <div className="steps-buttons">
            <div className="custom-back-button active" onClick={prevStep} style={{ cursor:'pointer' }}>
              <div className="button-back-icon" />
              <span className="button-back-text">Volver</span>
          </div>
        </div>
        </div>
        <div className="botonera-der">
          <Button id="pagar_con_pse" type="submit" disabled={isButtonDisabled} onClick={handlePay}>
            Pagar con PSE
          </Button>
        </div>
      </div>

      <div className="feet">
            <a href={ENV.BASE_BOX} className="exit_text">
              Salir
            </a>  
            <a href={ENV.BASE_BOX} className="exit_icon">
              <Image src={image.logOut} />
            </a>
          </div>

    </div>
  );
    
} 

export default StepThree;
